export enum ApiAccessModel {
    RoleBased = 1,
    PermissionBased = 2
}